export { default as Inpatient } from './Inpatient';
